
import { macroCondition, getGlobalConfig } from '@embroider/macros';


import implicitModules from "./-embroider-implicit-modules.js";


import * as amdModule0 from "./app.ts"
import * as amdModule1 from "./config/environment.js"
import * as amdModule2 from "./deprecation-workflow.ts"
import * as amdModule3 from "./router.ts"
import * as amdModule4 from "./services/store.ts"
import * as amdModule5 from "./transforms/boolean.js"
import * as amdModule6 from "./transforms/date.js"
import * as amdModule7 from "./transforms/number.js"
import * as amdModule8 from "./transforms/string.js"
import * as amdModule9 from "./instance-initializers/sentry-performance.js"
import * as amdModule10 from "./services/page-title.js"
import * as amdModule11 from "./initializers/ember-data.js"
import * as amdModule12 from "./services/store.js"
import * as amdModule13 from "./data-adapter.js"
import * as amdModule14 from "./templates/application.hbs"
import * as amdModule15 from "./controllers/application.ts"
import * as amdModule16 from "./routes/application.ts"
import * as amdModule17 from "./templates/login.hbs"
import * as amdModule18 from "./controllers/login.ts"
import * as amdModule19 from "./routes/login.ts"
import * as amdModule20 from "./templates/auth.hbs"
import * as amdModule21 from "./routes/auth.ts"
import * as amdModule22 from "./templates/auth/fans.hbs"
import * as amdModule23 from "./routes/auth/fans.ts"
import * as amdModule24 from "./templates/auth/finanzen.hbs"
import * as amdModule25 from "./routes/auth/finanzen.ts"
import * as amdModule26 from "./templates/auth/jugend.hbs"
import * as amdModule27 from "./routes/auth/jugend.ts"
import * as amdModule28 from "./templates/auth/kader.hbs"
import * as amdModule29 from "./routes/auth/kader.ts"
import * as amdModule30 from "./templates/auth/kalender.hbs"
import * as amdModule31 from "./routes/auth/kalender.ts"
import * as amdModule32 from "./templates/auth/liga.hbs"
import * as amdModule33 from "./routes/auth/liga.ts"
import * as amdModule34 from "./templates/auth/marketing.hbs"
import * as amdModule35 from "./routes/auth/marketing.ts"
import * as amdModule36 from "./templates/auth/smartphone.hbs"
import * as amdModule37 from "./routes/auth/smartphone.ts"
import * as amdModule38 from "./templates/auth/sponsoring.hbs"
import * as amdModule39 from "./routes/auth/sponsoring.ts"
import * as amdModule40 from "./templates/auth/stadion.hbs"
import * as amdModule41 from "./routes/auth/stadion.ts"
import * as amdModule42 from "./templates/auth/staff.hbs"
import * as amdModule43 from "./routes/auth/staff.ts"
import * as amdModule44 from "./templates/auth/taktik.hbs"
import * as amdModule45 from "./routes/auth/taktik.ts"
import * as amdModule46 from "./templates/auth/training.hbs"
import * as amdModule47 from "./routes/auth/training.ts"
import * as amdModule48 from "./templates/auth/transfermarkt.hbs"
import * as amdModule49 from "./routes/auth/transfermarkt.ts"
import * as amdModule50 from "./templates/index.hbs"
import * as amdModule51 from "./routes/index.ts"
import * as amdModule52 from "./templates/register.hbs"
import * as amdModule53 from "./routes/register.ts"

let exportFastbootModules = {};





export default Object.assign(
  {},
  implicitModules,
  {
"gyc/app": amdModule0,
"gyc/config/environment": amdModule1,
"gyc/deprecation-workflow": amdModule2,
"gyc/router": amdModule3,
"gyc/services/store": amdModule4,
"gyc/transforms/boolean": amdModule5,
"gyc/transforms/date": amdModule6,
"gyc/transforms/number": amdModule7,
"gyc/transforms/string": amdModule8,
"gyc/instance-initializers/sentry-performance": amdModule9,
"gyc/services/page-title": amdModule10,
"gyc/initializers/ember-data": amdModule11,
"gyc/services/store": amdModule12,
"gyc/data-adapter": amdModule13,
"gyc/templates/application": amdModule14,
"gyc/controllers/application": amdModule15,
"gyc/routes/application": amdModule16,
"gyc/templates/login": amdModule17,
"gyc/controllers/login": amdModule18,
"gyc/routes/login": amdModule19,
"gyc/templates/auth": amdModule20,
"gyc/routes/auth": amdModule21,
"gyc/templates/auth/fans": amdModule22,
"gyc/routes/auth/fans": amdModule23,
"gyc/templates/auth/finanzen": amdModule24,
"gyc/routes/auth/finanzen": amdModule25,
"gyc/templates/auth/jugend": amdModule26,
"gyc/routes/auth/jugend": amdModule27,
"gyc/templates/auth/kader": amdModule28,
"gyc/routes/auth/kader": amdModule29,
"gyc/templates/auth/kalender": amdModule30,
"gyc/routes/auth/kalender": amdModule31,
"gyc/templates/auth/liga": amdModule32,
"gyc/routes/auth/liga": amdModule33,
"gyc/templates/auth/marketing": amdModule34,
"gyc/routes/auth/marketing": amdModule35,
"gyc/templates/auth/smartphone": amdModule36,
"gyc/routes/auth/smartphone": amdModule37,
"gyc/templates/auth/sponsoring": amdModule38,
"gyc/routes/auth/sponsoring": amdModule39,
"gyc/templates/auth/stadion": amdModule40,
"gyc/routes/auth/stadion": amdModule41,
"gyc/templates/auth/staff": amdModule42,
"gyc/routes/auth/staff": amdModule43,
"gyc/templates/auth/taktik": amdModule44,
"gyc/routes/auth/taktik": amdModule45,
"gyc/templates/auth/training": amdModule46,
"gyc/routes/auth/training": amdModule47,
"gyc/templates/auth/transfermarkt": amdModule48,
"gyc/routes/auth/transfermarkt": amdModule49,
"gyc/templates/index": amdModule50,
"gyc/routes/index": amdModule51,
"gyc/templates/register": amdModule52,
"gyc/routes/register": amdModule53,
  },
  exportFastbootModules
);
